import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Checkbox,
  Text,
  Link,
  useDisclosure
} from '@chakra-ui/react';
import { downloadMedia } from '../../api/media';

const DISCLAIMER_TEXT = `These materials represent our collective industry voice — and that unity is what makes this campaign powerful. They were intentionally developed in partnership with a professional agency to ensure every element works together to deliver the strongest possible impact. To preserve that integrity, please use all materials exactly as provided without any edits or modifications.`;

const CONTACT_TEXT = `If you're interested in having materials branded with your company logo, or if something doesn't quite fit your needs, please contact `;

const CONTACT_EMAIL = 'marketing@iadc.org';

export const DownloadDisclaimerModal = ({ isOpen, onClose, onConfirm }) => {
  const [agreed, setAgreed] = useState(false);

  const handleClose = () => {
    setAgreed(false);
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
    setAgreed(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size="lg">
      <ModalOverlay bg="blackAlpha.700" />
      <ModalContent mx={4}>
        <ModalHeader color="brand.dkBlue" fontSize="lg" pb={2}>
          Before You Download
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4} fontSize="sm" color="brand.dkGray2" lineHeight="1.6">
            {DISCLAIMER_TEXT}
          </Text>
          <Text mb={6} fontSize="sm" color="brand.dkGray2" lineHeight="1.6">
            {CONTACT_TEXT}
            <Link href={`mailto:${CONTACT_EMAIL}`} color="brand.dkBlue" fontWeight="600">
              {CONTACT_EMAIL}
            </Link>
            .
          </Text>
          <Checkbox
            isChecked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            colorScheme="red"
            size="md"
          >
            <Text fontSize="sm" fontWeight="600">
              I acknowledge and agree to use these materials as provided
            </Text>
          </Checkbox>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={handleClose} size="sm">
            Cancel
          </Button>
          <Button
            bg="brand.ltRed"
            color="white"
            _hover={{ bg: 'brand.dkRed' }}
            onClick={handleConfirm}
            isDisabled={!agreed}
            size="sm"
          >
            Download
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const useDownloadWithDisclaimer = () => {
  const [pendingUuid, setPendingUuid] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const requestDownload = (uuid) => {
    setPendingUuid(uuid);
    onOpen();
  };

  const confirmDownload = () => {
    if (pendingUuid) downloadMedia(pendingUuid);
    setPendingUuid(null);
  };

  const cancelDownload = () => {
    setPendingUuid(null);
    onClose();
  };

  const DisclaimerModal = () => (
    <DownloadDisclaimerModal
      isOpen={isOpen}
      onClose={cancelDownload}
      onConfirm={confirmDownload}
    />
  );

  return { requestDownload, DisclaimerModal };
};
